import React from 'react'
import { Row, Col, Container } from 'react-angle-dashboard-components'

export const Header: React.FC<{ name: string }> = ({ name }) => {
  const welcomeText = `Welcome ${name}`

  return (
    <Container
      fluid
      style={{ background: '#F6F2EC', paddingTop: 100, paddingBottom: 50 }}
    >
      <Row noGutters className="px-4">
        <Col>
          <h1
            className="text-capitalize"
            style={{
              fontWeight: 600
            }}
          >
            {welcomeText}
          </h1>
          <h2
            style={{
              fontStyle: 'italic',
              fontSize: 16,
              color: 'gray'
            }}
          >
            Manage your book of business
          </h2>
        </Col>
      </Row>
    </Container>
  )
}
